export const SECONDARY_LIGHT = [
  "#FCFCFA",
  "#F9F7F2",
  "#F3EFE7",
  "#EAE5D8",
  "#E0D8C5",
  "#D4C7AF",
  "#C6B396",
  "#B39879",
  "#A27F5D",
  "#8E6A4A",
  "#6E5037",
  "#3B2A1D"
]
export const SECONDARY_DARK = [
  "#0F0E0C",
  "#151310",
  "#1C1915",
  "#231F19",
  "#2B261E",
  "#362E22",
  "#433626",
  "#56412C",
  "#A27F5D",
  "#C49974",
  "#E0B990",
  "#F3EFE7"
]

export const PRIMARY_DARK = [
  "#0A1411",
  "#0E1A16",
  "#11211C",
  "#142922",
  "#173127",
  "#1A3A2D",
  "#1E4334",
  "#23503D",
  "#3B9178",
  "#4EA58B",
  "#66BDA3",
  "#E6F2EC"
]

export const PRIMARY_LIGHT = [
  "#F6FBF7",
  "#E6F2EC",
  "#D3EBE0",
  "#B8DCCF",
  "#A4D2C2",
  "#8EC7B5",
  "#78BCA7",
  "#5EAB94",
  "#3B9178",
  "#26755F",
  "#1C5444",
  "#0E502F"
]

export const GREY_LIGHT = [
  "#F8F9FA",
  "#FBFCFD",
  "#F1F2F5",
  "#ECEDF0",
  "#E6E7EB",
  "#DFE2E6",
  "#D7DADF",
  "#C1C6CD",
  "#888E96",
  "#7E848C",
  "#686E76",
  "#11161C"
]

export const GREY_DARK = [
  "#151718",
  "#1A1C1E",
  "#202325",
  "#26282B",
  "#2B2E31",
  "#313438",
  "#3A3E42",
  "#4C4F55",
  "#696F77",
  "#787D85",
  "#9B9FA6",
  "#ECEDEE"
]

export const ERROR_LIGHT = [
  "#fff0ee",
  "#ffe6e2",
  "#ffd8d3",
  "#fac7be",
  "#f3b0a2",
  "#ea9280",
  "#e54d2e",
  "#db4324",
  "#ca3214",
  "#341711"
]

export const ERROR_DARK = [
  "#1D1412",
  "#2A1410",
  "#3B1813",
  "#481A14",
  "#541C15",
  "#652016",
  "#7F2315",
  "#A42A12",
  "#E54D2E",
  "#EC5E41",
  "#F16A50",
  "#FEEFEC"
]

export const WARNING_LIGHT = [
  "#FFF9ED",
  "#FEFDFB",
  "#FFF4D5",
  "#FFECBC",
  "#FFE3A2",
  "#FFD386",
  "#F3BA63",
  "#FFB224",
  "#FFA01C",
  "#EE9D2B",
  "#AD5700",
  "#4E2009"
]

export const WARNING_DARK = [
  "#1F1300",
  "#271700",
  "#341C00",
  "#3F2200",
  "#4A2900",
  "#573300",
  "#693F05",
  "#824E00",
  "#FFB224",
  "#FFCB47",
  "#F1A10D",
  "#FEF3DD"
]

export const INFO_LIGHT = [
  "#FBFDFF",
  "#F5FAFF",
  "#EDF6FF",
  "#E1F0FF",
  "#CEE7FE",
  "#B7D9F8",
  "#96C7F2",
  "#5EB0EF",
  "#0091FF",
  "#0081F1",
  "#006ADC",
  "#00254D"
]
export const INFO_DARK = [
  "#0F1720",
  "#0F1B2D",
  "#10243E",
  "#102A4C",
  "#0F3058",
  "#0D3868",
  "#0A4481",
  "#0954A5",
  "#0091FF",
  "#369EFF",
  "#52A9FF",
  "#EAF6FF"
]

export const mapColorsToMuiToken = (colors: string[]) => {
  return {
    50: colors[0],
    100: colors[1],
    200: colors[2],
    300: colors[3],
    400: colors[4],
    500: colors[5],
    600: colors[6],
    700: colors[7],
    800: colors[8],
    900: colors[9],
    A100: colors[10],
    A200: colors[11],
    main: colors[8],
    light: colors[7],
    lighter: colors[5],
    dark: colors[9],
    darker: colors[10]
  }
}

export const SUCCESS_LIGHT = [
  "#FBFEFB",
  "#F3FCF3",
  "#EBF9EB",
  "#DFF3DF",
  "#CEEBCF",
  "#B7DFBA",
  "#97CF9C",
  "#65BA75",
  "#46A758",
  "#3D9A50",
  "#297C3B",
  "#1B311E"
]

export const SUCCESS_DARK = [
  "#0D1912",
  "#0F1E13",
  "#132819",
  "#16301D",
  "#193921",
  "#1D4427",
  "#245530",
  "#2F6E3B",
  "#46A758",
  "#55B467",
  "#63C174",
  "#E5FBEB"
]

declare module "@mui/material/Avatar" {
  interface AvatarPropsColorOverrides {
    grey: true
  }
}
